import { Layout } from "antd";
import { useState } from "react";
import { RoutesList } from "../components/Routes";
import { Navbar } from "./Navbar";
import { useKeycloak } from "@react-keycloak/web";
import { LoadingLayout } from "./LoadingLayout";
import { AnimatePresence } from "framer-motion";
import { useGetUser, useThemeDetector, useGetTenantSettings } from "@hooks";
import { useExamStore, ThemeMode } from "@store";

export const MainLayout = () => {
  const { keycloak } = useKeycloak();
  const theme = useExamStore((state) => state.theme);
  const {isDarkTheme} = useThemeDetector();
 
  const {data: user, isLoading, isSuccess, isError, refetch, isFetching} = useGetUser(keycloak.authenticated);
  const {data: tenantSettings} = useGetTenantSettings(keycloak.authenticated);
  const [siderCollapsed, setSiderCollapsed] = useState(false);

  return (
    <AnimatePresence>
      {keycloak.authenticated && isSuccess ? (
        <Layout>
          <Layout.Sider
            collapsible
            collapsed={siderCollapsed}
            collapsedWidth={80}
            trigger={null}
            theme={theme === ThemeMode.System ? (isDarkTheme ? "dark" : "light") : (theme === ThemeMode.Dark ? "dark" : "light")}
            
            style={{
              boxShadow: (theme === ThemeMode.System ? (isDarkTheme ? "dark" : "light") : theme) === ThemeMode.Light ? "5px 0 30px rgba(0, 22, 84, 0.1)" : "5px 0 30px #060606",
              position: "sticky",
              left: 0,
              top: 0,
              height: "100vh",
              zIndex: 10,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Navbar user={user} tenantSettings={tenantSettings} isLoading={isLoading} collapsed={siderCollapsed} setCollapsed={setSiderCollapsed}/>
          </Layout.Sider>
          <Layout>
            <Layout.Content className="container-xl" style={{ padding: 15 }}>
                <RoutesList user={user} tenantSettings={tenantSettings}/>
            </Layout.Content>
          </Layout>
        </Layout>
      ) : (
        <LoadingLayout key={"loading"} isError={isError} isLoading={isLoading} isFetching={isFetching} refetch={refetch} />
      )}
      </AnimatePresence>
  );
};
